export const ENVIRONMENT = process.env.REACT_APP_ENV;
const BASENAME = '/';
const REDIRECT_URI = `${window.location.origin}${BASENAME}implicit/callback`;
const CLIENT_ID = process.env.REACT_APP_CLIENT_ID_CLIENT_ID || 'nike.techops.retail-store-insights';
const OKTA_TESTING_DISABLEHTTPSCHECK =
  process.env.REACT_APP_OKTA_TESTING_DISABLEHTTPSCHECK || false;
let oktaIssuer = process.env.REACT_APP_OKTA_QA;
let apiEndPoint = process.env.REACT_APP_INSIGHTS_API_DEV;

switch (ENVIRONMENT) {
  case 'prod':
    apiEndPoint = process.env.REACT_APP_INSIGHTS_API_PROD;
    oktaIssuer = process.env.REACT_APP_OKTA_PROD;
    break;
  case 'dev':
    apiEndPoint = process.env.REACT_APP_INSIGHTS_API_DEV;
    oktaIssuer = process.env.REACT_APP_OKTA_QA;
    break;
  default:
    console.log('no REACT_APP_ENV found');
    apiEndPoint = process.env.REACT_APP_INSIGHTS_API_DEV;
    oktaIssuer = process.env.REACT_APP_OKTA_QA;
    break;
}

const config = {
  oidc: {
    clientId: CLIENT_ID,
    issuer: oktaIssuer,
    redirectUri: REDIRECT_URI,
    scopes: ['openid', 'profile', 'email', 'techops.rss.read'],
    pkce: true,
    disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK,
  },
  resourceServer: {
    insightsApiUrlStores: apiEndPoint + 'stores',
    insightsApiUrlActiveEvents: apiEndPoint + 'events?isactive=true',
    insightsApiUrlEvents: apiEndPoint + 'events?',
    insightsApiUrlLandingPage: apiEndPoint + 'landingpagecounts',
    insightsApiUrlLandingPageKeyMarket: apiEndPoint + 'landingpagecounts?IsKeyMarket=true',
    insightsApiUrlTrendingChart: apiEndPoint + 'trendingchartdata?',
    insightsApiUrlStoreHealthChartData: apiEndPoint + 'StoreHealthChartData',
    insightsApiUrlCoordinates: apiEndPoint + 'coordinates?',
    insightsApiUrlStoreIssues: apiEndPoint + 'storeissuecount?',
    insightsApiUrlTrendingIssueCount: apiEndPoint + 'trendingissuecount?',
    insightsApiUrlMinimumStoreInfo: apiEndPoint + 'MinimumStoreInfo',
    insightsApiUrlLogUserAction: apiEndPoint + 'LogUserAction',
    insightsApiUrlTreeMenuData: apiEndPoint + 'TreeMenuData',
    insightsApiUrlTopEvents: apiEndPoint + 'TopEvents',
    insightsApiUrlTableEvents: apiEndPoint + 'TableEvents',
    insightsApiUrlDeviceHealthCount: apiEndPoint + 'DeviceHealthCount',
    insightsApiUrlRetailRecurringPhysical: apiEndPoint + 'RetailRecurringPhysical',
    insightsApiUrlRetailRecurringPhysicalReport: apiEndPoint + 'RetailRecurringPhysicalReport',
    insightsApiUrlRetailDevices: apiEndPoint + 'RetailDevices',
    insightsApiUrlStoreServices: apiEndPoint + 'StoreServices',
    insightsApiUrlDistinctIdfSearchItems: apiEndPoint + 'DistinctIdfSearchItems',
    insightsApiUrlServicesByStore: apiEndPoint + 'ServicesByStore',
    insightsApiUrlPayloadIngestion: apiEndPoint + 'PayloadIngestion',
    insightsApiUrlSwitchData: apiEndPoint + 'SwitchConnectivity',
    insightsApiUrlSwitchPortHistory: apiEndPoint + 'SwitchPortHistory',
    insightsApiUrlMinimumSiteInfo: apiEndPoint + 'MinimumSiteInfo',
    insightsApiUrlDevices: apiEndPoint + 'Devices',
    insightsApiUrlNPOS: apiEndPoint + 'npos',
    insightsApiUrlStoresData: apiEndPoint + 'Stores',
    insightsApiUrlHistoryStoreData: apiEndPoint + 'DeviceHistory',
  },
  app: {
    basename: BASENAME,
  },
};

export default config;
